module.exports = __webpack_public_path__ + "img/Hypoxia-PRCA_10X_AIC.cee9d32a.png";